import { GET, PATCH, POST, DELETE } from "Data/API/Request";
import { deserializeJsonApiData, serializeJsonApiData } from "Data/Utils/Json";
import {
	IApiUser, IDataPage, IIndexSignature, ILoginUserArgs, IResetPasswordArgs, IUser, IWithApiData
} from "Interfaces";

export const loginUser = (loginUserArgs: ILoginUserArgs) => {
	return POST<IApiUser>("auth/login", loginUserArgs);
};

export const logoutUser = () => {
	return POST("auth/logout");
};

export const forgotPassword = (email: string) => {
	return POST("auth/forgot-password", { email });
};

export const resetPassword = (args: IResetPasswordArgs) => {
	return POST("auth/reset-password", { ...args });
};

export const getUsers = (token: string, params?: IIndexSignature<string | number>) => {
	return GET("users", token, { ...params }).then((response: IWithApiData) => {
		return deserializeJsonApiData<Partial<IUser>[]>(response).then((user: Partial<IUser>[]) => {
			return { ...response, data: user } as IDataPage<IUser>;
		});
	});
};

export const getUser = (id: string, token: string) => {
	return GET(`users/${ id }`, token)
		.then((response: IWithApiData) => {
			return deserializeJsonApiData<IUser>(response);
		});
};

export const createUser = (user: IUser, token: string) => {
	return POST(
		"users",
		serializeJsonApiData("user", user),
		token
	).then((response: IWithApiData) => {
		return deserializeJsonApiData<IUser>(response);
	});
};

export const updateUser = (user: Partial<IUser>, token: string) => {
	return PATCH(
		`users/${ user?.id }`,
		token,
		serializeJsonApiData("user", user)
	).then((response: IWithApiData) => {
		return deserializeJsonApiData<IUser>(response);
	});
};

export const deleteUser = (id: string, token: string) => {
	return DELETE(`users/${ id }`, token)
		.then(() => id);
};
